export default __webpack_public_path__ + "static/media/mic-on.cf507ef5.svg";